import  { useContext } from "react";
import ScrollToTop from "../scroll";
import { IonLabel, IonToolbar, IonButton, IonButtons, IonPage, IonHeader, IonContent, IonCard, IonCardContent } from "@ionic/react";
import { ArrowBackSharp } from "@mui/icons-material";
import { useHistory } from "react-router";
import { Colour, FontType, Hindit } from "../global";

export default function Terms() {
 let history = useHistory();
 const [clr,] = useContext(Colour);
 let color,colori, colorh;
 if(clr === "1") {
    color = "black";
    colori = ""
    colorh = "primary"
   }
   if(clr === "2") {
    color = "black";
    colori = "secondary"
    colorh = "warning"
   }
   if(clr === "3") {
    color = "black";
    colori = "secondary"
    colorh = "success"
   }
   if(clr === "4") {
    color = "black";
    colori = "secondary"
    colorh = "tertiary"
   }
   if(clr === "5") {
    color = "white";
    colori = "dark"
    colorh = "warning"
   }
   if(clr === "6") {
    color = "white";
    colori = "dark"
    colorh = "tertiary"
   }


 const [font,] = useContext(FontType);
 let fon;
 if (!font) fon = "Calibri, sans-serif";
 else fon = "Times New Roman, serif";
 const [hindit,] = useContext(Hindit);

 return (
   <IonPage>
    <ScrollToTop />
    <IonHeader>
   <IonToolbar color={colorh}>
    <IonButtons slot="start" onClick={() => {
          history.push("/home");
    }}>
     <IonButton>
     <ArrowBackSharp style={{ fontSize: 30 }} />
     </IonButton>
    </IonButtons>
    <IonLabel style={{ fontFamily: `${fon}` }}>{hindit ? "टर्म्स ऑफ़ सर्विस" : "Terms of Service"}</IonLabel>
   </IonToolbar>
   </IonHeader>
   <IonContent color={colori} scrollEvents={true}>
   <div style={{ padding: "10px", textAlign: "justify", textJustify: "auto" }}>
    <IonCard color={colori} style={{ color: `${color}`, fontFamily: "Calibri, sans-serif"  }}>
        <IonCardContent>
   {hindit ? 
     <p style={{ fontFamily: `${fon}`, fontSize: "18px" }}>
     हमारा ऐप आपकी जानकारी को नहीं जमा करता। यह किसी डेटाबेस का उपयोग नहीं करता और किसी अन्य सर्वर से कनेक्ट नहीं होता। आपकी चीजें, जैसे कि बुकमार्क्स और सेटिंग्स, आपके डिवाइस पर ही रहती हैं। आप इसे गूगल ड्राइव पर बैकअप कर सकते हैं, लेकिन हम वहाँ कुछ भी नहीं देख सकते या बदल सकते।
     </p>
    : 
    <p style={{  fontFamily: `${fon}`, fontSize: "18px" }}>
   Our app doesn't collect your info. It doesn't use any databases or connect to other servers. Your stuff, like bookmarks and settings, stays on your device. You can back it up to Google Drive, but we can't see or change anything there.
     </p>
   }
   </IonCardContent>
   </IonCard>
     </div>
     <div style={{textAlign:"center"}}>
     <IonButton color={colorh} onClick={()=>{history.push("/home/privacy")}}>
        {hindit ? "प्राइवेसी पॉलिसी" : "Privacy Policy"}
     </IonButton>
     </div>
     
   </IonContent>
   </IonPage>

 );
}
